<template>
	<div class="page" @click="apply">
		<img class="title" :src="mainTitle" alt="标题" />
		<p class="dw strong">主办单位：中国青年报社</p>
		<p class="dw strong">指导单位：中国青年志愿者协会</p>
    <div class="content">
      <p class="instruction-text">• 入选教育部<span class="link-text" >《2025-2028学年面向中小学生的全国性竞赛活动名单》</span></p>
      <p class="instruction-text">• 本赛事<span class="link-text" >全程免费</span></p>
      <p class="instruction-text">• 官方唯一参赛平台为<span class="link-text" >中国青年报客户端</span></p>
      <p class="instruction-text">• <span class="link-text" ><span>下载客户端</span>完成报名信息确认</span></p>

    </div>
		<!-- <div class="height-100"></div> -->
		<Footer></Footer>
	</div>
</template>

<script>
import Footer from "../components/Footer";

export default {
	components: {
		Footer
	},
	data() {
		return {
			// 图片导入
			mainTitle: require('@/assets/images/title.png'),
			contactList: []
		}
	},
	mounted() {

	},
	methods: {
		apply(){
      // alert("本活动仅限客户端内参与哦！")
      let page = btoa("pages/main/index")
      var urlShare = `cyol://news.cyol.com/share?content_type=min_program/redirect_type=default/min_program=__UNI__0BB6A9F/page=${page}/post_id=3nG702i0`;
      location.href='http://a.app.qq.com/o/simple.jsp?pkgname=com.hzpd.zqzx&ios_scheme='+encodeURI(urlShare)+'&android_scheme='+encodeURI(urlShare);
    }
	}
}
</script>

<style scoped>
.height-100 {
	height: 112px;
}

.page {
	min-height: calc(100vh - 112px);
  background: url("../assets/images/dx_bj.jpg");
  background-size: 100% 100%;
	background-repeat: no-repeat;
	position: relative;
	text-align: justify;
  overflow: hidden;
  color: #FFFFFF;
}


.title {
	width: 660px;
	height: 180px;
	margin: 60px auto 60px;
	display: block;
	max-width: 90%;
}
.content {
  padding: 100px 0px 0;
  font-size: 26px;
}

.title-text {
	display: block;
	margin: 80px auto 8px;
	text-align: center;
	font-weight: 800;
	font-size: 55px;
	color: #FFFFFF;
	line-height: 94px;
}

p {
  width: 660px;
  margin: auto;
  line-height: 1.8em;
}
.instruction-text {
  margin-bottom: 30px;
}
p span {
  font-weight: bold;
  font-size: 30px;
}
p span span {
  text-decoration: underline;
  color: #f9e885;
}
.dw {
  font-size: 24px;
  margin-bottom: 10px;
}
.strong {
  font-weight: bold;
}


</style>
